/**
 * Brand tokens — single source of truth for the CRA3D customer-facing brand.
 *
 * The public brand name is CRA3D™ (Career Repath Assessment: Three Directions),
 * founded by Mark Dean, a product of The Dean Offices LLC. Change the
 * exports below to re-brand the app without touching any component. Colors,
 * typography and layout live in /app/frontend/src/index.css as CSS variables
 * (--cra3d-* token names) — see /app/memory/PRD.md for the 2026-02 zero-legacy
 * rebrand record.
 *
 * Website token `website` is used as canonical brand-website TEXT in identity
 * lines (footer identity, email templates, PDF metadata). It is intentionally
 * NOT hyperlinked in the app until the CRA3D.com custom domain is connected
 * at cutover — no dead links.
 */
export const BRAND = {
  name: "CRA3D",
  name_accent: "3D",
  trademark: "\u2122",
  full_name: "Career Repath Assessment: Three Directions",
  tagline: "Three Directions. One Future Forward.",
  promise:
    "Assess your experience. Discover 3 Lanes of Direction. Build what's next.",
  official_description:
    "CRA3D helps people recognize skills gained through real experience, explore work they genuinely want, learn practical AI skills, and build an evidence-based 30/60/90-day career plan.",
  supporting_notice:
    "Working development build — a private space to describe real work and life experience. No employment guarantees. No purpose-discovery claims.",
  founder: "Mark Dean",
  company: "The Dean Offices LLC",
  website: "CRA3D.com",
  ownership_statement:
    "CRA3D\u2122 \u2014 Founded by Mark Dean \u00b7 A product of The Dean Offices LLC.",
  // Approved customer-facing footer identity (2026-02 landing refinement).
  // Replaces the previous "Working development build" copyright line.
  // The year is intentionally static here — footers call
  // `new Date().getFullYear()` where a dynamic year is required and
  // then concatenate this identity line, so the single source of truth
  // for the identity wording stays here.
  footer_identity:
    "The Dean Offices LLC. CRA3D\u2122 is a product of The Dean Offices LLC.",
  // Preview-environment-only notice. Rendered conditionally via
  // `isPreviewEnv()` so a production build never carries this label.
  // Keep this short — it sits in the footer identity line.
  preview_notice:
    "Preview environment \u2014 not for public distribution.",
};

export default BRAND;
